import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DomainSettings } from '../models/settings/domain-settings';
import { DefaultHttpService } from './default-http.service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class SettingsService extends DefaultHttpService {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    getSettings(): Observable<DomainSettings> {
        return this.http.get<DomainSettings>(this.baseUrl + `/api/domain/configuration`);
    }
}
